import Swiper from 'swiper';
import { Navigation, A11y, FreeMode } from 'swiper/modules';
import { animate } from '../../core/animations';
import sliderADA from '../../components/slider/ada';

const initSlider = (slider) => {
  const swiper = new Swiper(slider, {
    modules: [ Navigation, A11y, FreeMode ], // https://swiperjs.com/swiper-api#using-js-modules
    a11y: {
      enabled: true,
      prevSlideMessage: window.theme.strings.swiperPrevSlide,
      nextSlideMessage: window.theme.strings.swiperNextSlide,
      containerMessage: window.theme.strings.swiperContainer,
    },
    slidesPerView: 1.4,
    spaceBetween: 10,
    loop: true,
    loopAddBlankSlides: false,
    autoHeight: true,
    freeMode: true,
    autoplay: false,
    // navigation: false,
    breakpoints: {
      769: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        freeMode: false,
        navigation: {
          nextEl: '.three-slides .swiper-button-next',
          prevEl: '.three-slides .swiper-button-prev',
        },
      }
    },
    on: {
      init: function () {
        animate();
        sliderADA(document.querySelector('[data-three-slides-slider].swiper'));
      },
    }
  });
};

export default () => {
  const sliders = document.querySelectorAll('[data-three-slides-slider].swiper');

  if (sliders.length === 0) {
    return false;
  }

  sliders.forEach(slider => {
    initSlider(slider);
  });
};
